import { render } from "./home-sec7.vue?vue&type=template&id=81546e40"
import script from "./home-sec7.vue?vue&type=script&lang=js"
export * from "./home-sec7.vue?vue&type=script&lang=js"

import "./home-sec7.vue?vue&type=style&index=0&id=81546e40&lang=css"

import exportComponent from "C:\\Users\\jomon\\OneDrive\\Desktop\\algorithma-website-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__